import { getDomain } from "router/filter";

export const buildVisalOfferInput = (
    variables: any,
    employeeId: string,
) => ({
    brokerage: parseFloat(variables.brokerage),
    insurer_id: variables.insurer_id,
    premium: parseFloat(variables.premium),
    policy_number: variables.policy_number,
    offer_details: JSON.stringify(variables.offer_details),
    class_of_business_id: variables.class_of_business_id?.class_of_business_id,
    employee_id: employeeId,
    rate: parseFloat(variables.rate),
    commission: parseFloat(variables.commission),
    facultative_offer: parseFloat(variables.facultative_offer),
    sum_insured: parseFloat(variables.sum_insured),
    insured_by: variables.insured_by,
    currency: variables.currency,
    risk_location: variables.risk_location,
    offer_comment: variables.comment,
    period_of_insurance_from: variables.period_of_insurance_from,
    period_of_insurance_to: variables.period_of_insurance_to,
});

export const buildKEKOfferInput = (
    variables: any,
    employeeId: string,
    isUpdate = false,
) => ({
    brokerage: parseFloat(variables.brokerage),
    insurer_id: variables.insurer_id,
    premium: parseFloat(variables.premium),
    policy_number: variables.policy_number,
    offer_details: JSON.stringify(variables.offer_details),
    class_of_business_id: variables.class_of_business_id?.class_of_business_id,
    employee_id: employeeId,
    rate: parseFloat(variables.rate),
    commission: parseFloat(variables.commission),
    facultative_offer: parseFloat(variables.facultative_offer),
    sum_insured: parseFloat(variables.sum_insured),
    insured_by: variables.insured_by,
    currency: variables.currency,
    offer_comment: variables.comment,
    period_of_insurance_from: variables.period_of_insurance_from,
    period_of_insurance_to: variables.period_of_insurance_to,
    reinsurer_id: variables.reinsurer_id,
    business_state: variables.business_state,
    co_insurance_share: parseFloat(variables.co_insurance_share),
    ex_currency: isUpdate
        ? variables.addExchangeRate
            ? variables.ex_currency
            : null
        : variables.ex_currency,
    ex_rate: isUpdate
        ? variables.addExchangeRate
            ? parseFloat(variables.ex_rate)
            : null
        : parseFloat(variables.ex_rate),
    information_comment: variables.information_comment,
    payment_type: {
        [variables.payment_type]:
            variables.payment_type === "payable_in_full"
                ? "Facultative Premium payable in full at inception"
                : variables.no_of_installments,
    },
});

export const buildOfferInput = (variables: any, employeeId: string) => {
    const domain = getDomain();
    if (domain === "KEK") {
        return buildKEKOfferInput(variables, employeeId);
    }
    return buildVisalOfferInput(variables, employeeId);
};
